<common-header [title]="title" [items]="items"></common-header>

<app-handpay-voucher-list [isReport]="true"></app-handpay-voucher-list>
